import React, { Component } from 'react';
import { Header, Dimmer, Loader } from 'semantic-ui-react';

class App extends Component {

  render() {
    return (
      <div>
        <Dimmer active={this.props.load} page>
          <Header as='h2' inverted style={{marginTop: '50%'}}>
            <Loader /><br/><br/><br/>
            {this.props.message}
          </Header>
        </Dimmer>
      </div>
    );
  }
}

export default App;
